import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { IActionFormProps, isValidUrl } from '@makyoapp/makyo-common'
import { Button, ButtonVariant, Field, Label } from '@makyoapp/makyo-ui'

import { parseSingleCellValue } from '@/core/app-builder/parser/single-cell'
import { useForm } from '@/lib/use-form'
import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { ActionInputdata } from '@/shared/action.types'
import { ActionInputV2 } from '@/components/ActionInputV2'

/**
 * @todo replace `getRowValueIfExist`
 */
export default function ActFormOpenFile({ onSubmit, onDismiss, initialData }: IActionFormProps) {
  const { dbClient } = useDbClientContext()
  const { activeLayerDetailRowIndex } = useActiveLayerContext()

  const { form, onSubmit: onFormSubmit } = useForm<ActionInputdata>({
    defaultValues: {
      ...((initialData || {}) as ActionInputdata),
    },
    async validate(data, setError) {
      let isManualInput = !data.tableId
      let value =
        (await parseSingleCellValue(
          { col: data.value, tbl: data.tableId, row: activeLayerDetailRowIndex },
          dbClient
        )) ?? data.value
      let isEmpty = !value?.trim().length

      let errMessage = isEmpty
        ? 'Please choose a file'
        : isManualInput && !isValidUrl(value)
          ? 'Invalid file URL'
          : null

      setError('value', errMessage)
    },
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  const value = form.getValues('value')
  const invalidForm = !value || !!form.errors

  return (
    <div>
      <div className='p-4'>
        <Field>
          <Label required>File</Label>

          <ActionInputV2
            type='file'
            value={form.getValues()}
            columnTypes={[ColumnTypes.URL, ColumnTypes.Image, ColumnTypes.Attachment]}
            onChange={(value) => {
              form.setValues(value)
            }}
            error={form.errors?.value}
          />
        </Field>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit} disabled={invalidForm || form.isValidating}>
          {form.isValidating ? <Trans>Loading...</Trans> : <Trans>Save</Trans>}
        </Button>
      </div>
    </div>
  )
}
